"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var toNumber_1 = __importDefault(require("lodash/toNumber"));
var isNumber_1 = __importDefault(require("lodash/isNumber"));
var round_1 = __importDefault(require("lodash/round"));
var NumberUtil = /** @class */ (function () {
    function NumberUtil() {
    }
    NumberUtil.parse = function (stringOrNumber) {
        if (Array.isArray(stringOrNumber)) {
            return stringOrNumber.map(function (v) { return NumberUtil.parseNumber(v); });
        }
        return NumberUtil.parseNumber(stringOrNumber);
    };
    NumberUtil.parseNumber = function (stringOrNumber) {
        var value = toNumber_1.default(stringOrNumber);
        if (isNumber_1.default(value) && !isNaN(value)) {
            return value;
        }
        return undefined;
    };
    NumberUtil.formattedNumber = function (stringOrNumber, minFraction) {
        if (minFraction === void 0) { minFraction = 0; }
        var value = toNumber_1.default(stringOrNumber);
        if (isNumber_1.default(value) && !isNaN(value)) {
            return value.toLocaleString(navigator.language, {
                minimumFractionDigits: minFraction,
            });
        }
        return undefined;
    };
    NumberUtil.round = function (number, decimalPlaces) {
        if (decimalPlaces === void 0) { decimalPlaces = 4; }
        return round_1.default(number, decimalPlaces);
    };
    NumberUtil.humanCount = function (rawCount) {
        var count = rawCount + 0;
        var thresh = 1000;
        if (Math.abs(count) < thresh) {
            return "" + count;
        }
        var units = ['K', 'mil'];
        var u = -1;
        do {
            count /= thresh;
            ++u;
        } while (Math.abs(count) >= thresh && u < units.length - 1);
        return "" + count.toFixed(1) + units[u];
    };
    return NumberUtil;
}());
exports.default = NumberUtil;
//# sourceMappingURL=NumberUtil.js.map